import type { IconType } from 'react-icons';

/** Grupos do Cognito que decidem a visibilidade de um atalho. Mesmo vocabulário da Sidebar. */
export type GrupoAtalho = 'admin' | 'clubes' | 'ciclista';

export interface AtalhoOutros {
  path: string;
  label: string;
  icon: IconType;
  /** Grupos que enxergam o atalho. Vazio nunca: um atalho sem grupo não aparece para ninguém. */
  groups: GrupoAtalho[];
}

/**
 * Fonte declarativa única dos atalhos do hub "Outros".
 *
 * O hub existe para que telas secundárias não precisem cada uma de um item no
 * sidebar. Declarar em lista, no mesmo formato do `NAV_ITEMS`, é o que faz o hub
 * cumprir esse propósito: acrescentar uma tela futura é acrescentar uma entrada
 * aqui, e a visibilidade por grupo fica no mesmo lugar e na mesma forma da
 * navegação — em vez de uma segunda regra de RBAC visual, escrita de outro
 * jeito, para manter em sincronia.
 *
 * A visibilidade de cada entrada tem que corresponder ao guard da rota em
 * `App.tsx`: atalho exibido cujo guard recusa vira "acesso negado" no clique.
 * A autorização real continua no backend.
 *
 * Vazia por ora: o Mapa de Clubes, último atalho, virou item do menu lateral.
 * Sem atalho visível, o item "Outros" some do menu sozinho (`visibleNavItems`),
 * mas o hub e a rota `/outros` ficam, para a próxima tela secundária entrar aqui.
 */
export const ATALHOS_OUTROS: AtalhoOutros[] = [];

/** Atalhos visíveis para os grupos informados, na ordem de declaração. */
export function atalhosVisiveis(grupos: GrupoAtalho[]): AtalhoOutros[] {
  if (ATALHOS_OUTROS.length === 0) return [];
  return ATALHOS_OUTROS.filter((atalho) => atalho.groups.some((g) => grupos.includes(g)));
}
